import { EstadoCivilPorExtenso } from 'src/tipos'

export const SELECT_ESTADO_CIVIL = Object.keys(EstadoCivilPorExtenso).map(
  item => ({
    id: item,
    texto: EstadoCivilPorExtenso[item as keyof typeof EstadoCivilPorExtenso]
  })
)
